import React from 'react'
import moment from 'moment'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// components
import MinAgeEligibility from 'components/shared/MinAgeEligibility'

const MinAgeWarning = props => {
  const { birthdate, season } = props
  const { youngCamperCutoff } = season
  const isYoungCamper = moment(birthdate) > moment(youngCamperCutoff)

  if (!isYoungCamper) {
    return null
  }

  return (
    <Box mt={2}>
      <MinAgeEligibility>
        <Typography paragraph fontWeight='fontWeightBold'>
          Age Eligibility
        </Typography>
      </MinAgeEligibility>
    </Box>
  )
}

export default MinAgeWarning
